// extracted by mini-css-extract-plugin
module.exports = {"form":"SearchForm_form__3kOsZ","input":"SearchForm_input__hzrFr","heading":"SearchForm_heading__ouXyL","tagsInputContainer":"SearchForm_tagsInputContainer__78jIx"};